import PrepaidCardImageApi from '@apis/prepaid/PrepaidCardImageApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const prepaidCardImageQueries = createQueryKeys('prepaidCardImages', {
    list: () => ({
        queryKey: ['prepaidCardImages'],
        queryFn: () => PrepaidCardImageApi.getPrepaidCardImages(),
    }),
    detail: (id: string) => ({
        queryKey: ['prepaidCardImage', id],
        queryFn: () => PrepaidCardImageApi.getPrepaidCardImage(id),
    }),
});

export default prepaidCardImageQueries;
